import React, { Component } from 'react';
import logo from '../../Logo_Gregg.svg';
import errorIcon from '../../errorCinza.png';
import './index.css'
import request from '../client/client';

class Login extends Component {
  state = {
    loginError: null
  }
  /*Responsável por gerar os states username e password */
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  //tentar adicionar tratamento de erros
  signin = async (e) => { 
    e.preventDefault();
    try {
      const user = await request.post('/cashiers/signin', {
        "email": this.state.email,
        "password": this.state.password
      })

      await localStorage.setItem('token', user.data.token);
      await localStorage.setItem('id', user.data.cashier._id);
      this.props.history.replace('/');
    } catch(error) {
        if(error.response.status === 401) {
          this.setState({
            loginError: "Login e/ou senha inválidos"
          })
        }
        else{
          this.setState({
            loginError: "Nossos sistemas estão passando por problemas, tente mais tarde"
          })
        }
    };
  }

  render() {
    return (
      <div className="text-center">
        <img src={logo} alt="gregg" width="135"/>
        <form onSubmit={this.signin}>
          <input
            className="form-item"
            placeholder="Login"
            name="email"
            type="text"
            onChange={this.handleChange}
          />
          <input
            className="form-item"
            placeholder="Password"
            name="password"
            type="password"
            onChange={this.handleChange}
          />
          {
          !!this.state.loginError &&
          <div className="error-message">
            <img src={errorIcon} alt="ícone de erro"/>
            {this.state.loginError}
          </div>
          }
          <input
            className="form-submit"
            value="Entrar"
            type="submit"
          />
        </form>
      </div>
    )
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/index.js